"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var OwlChild = (function () {
    function OwlChild(el, ngZone) {
        this.el = el;
        this.ngZone = ngZone;
        this.owlClass = true;
        this.options = {};
        $ = $ || jQuery;
    }
    OwlChild.prototype.ngAfterViewInit = function () {
        var _this = this;
        if ((typeof window != 'undefined') && $ && typeof $.fn.owlCarousel == 'function') {
            this.$owl = $(this.el.nativeElement);
            this.ngZone.runOutsideAngular(function () {
                _this.$owl.owlCarousel(_this.options);
            });
        }
    };
    OwlChild.prototype.trigger = function (action, options) {
        var _this = this;
        if (this.$owl) {
            this.ngZone.runOutsideAngular(function () {
                _this.$owl.trigger(action, options);
            });
        }
    };
    OwlChild.prototype.ngOnDestroy = function () {
        var _this = this;
        if (this.$owl) {
            this.ngZone.runOutsideAngular(function () {
                _this.$owl.trigger('destroy.owl.carousel').removeClass('owl-loaded');
            });
            delete this.$owl;
        }
    };
    __decorate([
        core_1.HostBinding('class.owl-carousel'), 
        __metadata('design:type', Object)
    ], OwlChild.prototype, "owlClass", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], OwlChild.prototype, "options", void 0);
    OwlChild = __decorate([
        core_1.Component({
            selector: 'owl-carousel-child',
            template: '<ng-content></ng-content>'
        }), 
        __metadata('design:paramtypes', [core_1.ElementRef, core_1.NgZone])
    ], OwlChild);
    return OwlChild;
}());
exports.OwlChild = OwlChild;
//# sourceMappingURL=owl-child.component.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/node_modules/ngx-owl-carousel/src/owl-child.component.js
// module id = ../../../../ngx-owl-carousel/src/owl-child.component.js
// module chunks = vendor